import { useTranslation } from 'react-i18next'
import { useCanManageStages } from '@/components/shared/manage-links'
import { LifecycleTab } from '@/pages/cdp/lifecycle-tab'
import { LifecycleStagesTab } from './lifecycle-stages-tab'

/**
 * Cài đặt → Pipeline khách hàng: gộp "Pipeline khách hàng" (đặt giai đoạn) và "Vòng đời khách hàng" (phễu + lịch sử)
 * cũ — cùng một chuỗi giai đoạn. Chủ tổ chức / quản trị viên thấy phần đặt giai đoạn (backend PUT /cdp/lifecycle/stages);
 * quản lý chỉ thấy phễu và các lần chuyển giai đoạn.
 */
export function CustomerPipelineTab() {
  const canManageStages = useCanManageStages()
  const { t } = useTranslation('settings')
  return (
    <div className="space-y-8">
      {canManageStages && (
        <section className="space-y-3">
          <h2 className="text-base font-semibold">{t('settings:pipeline.stagesHeading')}</h2>
          <LifecycleStagesTab />
        </section>
      )}
      <LifecycleTab />
    </div>
  )
}
